export const FIRE_DEVELOPER = 'FIRE_DEVELOPER'
export const HIRE_DEVELOPER = 'HIRE_DEVELOPER'
export const UPDATE_DEVELOPER_INFO = 'UPDATE_DEVELOPER_INFO'



// WEBPACK FOOTER //
// ./src/redux/developers/action-types.js